import React from "react"
import { Layout } from "../components/Layout"
import { Typography } from "../components/Typography"
import tw from "twin.macro"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { Heading } from "../components/Heading"

export default function Article({ data }: { data: QueryResult }) {
  return (
    <Layout>
      <Heading title={data.mdx.frontmatter.title} />
      <Typography variant="small" css={tw`text-gray-medium mb-8`}>
        {data.mdx.frontmatter.date}
      </Typography>
      <article css={tw`prose max-w-none`}>
        <MDXRenderer>{data.mdx.body}</MDXRenderer>
      </article>
    </Layout>
  )
}

type QueryResult = {
  mdx: {
    body: string
    frontmatter: {
      title: string
      date: string
    }
  }
}

export const query = graphql`
  query($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`
